/**
 * FT13-U20: the FIN-F04 reports with no screen until now (FSD 2.2.4.10):
 * Depreciation Schedule and Forecast, and Capital Expenditure Against Budget.
 *
 * The INT packet spreads `ASSETS_REPORT_ROUTES` and adds the nav items
 * `assets-depreciation-forecast` and `assets-capex-vs-budget`. Both routes'
 * permission is their endpoint's: `assets.report.read`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { ASSETS_PERMISSIONS } from '@/modules/assets/permissions'

export const DEPRECIATION_FORECAST_PATH = '/assets/reports/depreciation-forecast'
export const CAPEX_VS_BUDGET_PATH = '/assets/reports/capex-vs-budget'

export const ASSETS_REPORT_ROUTES: RouteRecordRaw[] = [
  {
    path: DEPRECIATION_FORECAST_PATH,
    name: 'assets-depreciation-forecast',
    component: () => import('@/modules/assets/reports/DepreciationForecastView.vue'),
    meta: {
      titleKey: 'assets.routeTitles.depreciationForecast',
      permission: ASSETS_PERMISSIONS.reportRead,
    },
  },
  {
    path: CAPEX_VS_BUDGET_PATH,
    name: 'assets-capex-vs-budget',
    component: () => import('@/modules/assets/reports/CapexVsBudgetView.vue'),
    meta: {
      titleKey: 'assets.routeTitles.capexVsBudget',
      permission: ASSETS_PERMISSIONS.reportRead,
    },
  },
]
